import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-no-request-found',
    templateUrl: './no-request-found.component.html',
    styleUrl: './no-request-found.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NoRequestFoundComponent implements OnInit {
  public componentData: CmsParagraphComponent;
  @Input() data: Observable<CmsParagraphComponent>;
  constructor(public component: CmsComponentData<CmsParagraphComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });  
  }
}
